<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-product-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <form @submit.prevent="submitForm">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">SKU Data Table</label>
              <select class="form-control shadow-none rounded-0 text-black" v-model="form.TableID">
                <option v-for="table in skuTables" :key="table.tableID" :value="table.tableID">
                  {{ table.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Total Levels</label>
              <input
                type="number"
                class="form-control shadow-none rounded-0 text-black"
                v-model.number="form.TotalLevels"
                min="1"
                step="1"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Location Quantity</label>
              <input
                type="number"
                class="form-control shadow-none rounded-0 text-black"
                v-model.number="form.LocationQuantity"
                min="50"
                step="50"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Pallet Width</label>
              <input type="number" class="form-control shadow-none rounded-0 text-black" v-model.number="form.PalletWidth" step="0.01" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Pallet Depth</label>
              <input type="number" class="form-control shadow-none rounded-0 text-black" v-model.number="form.PalletDepth" step="0.01" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Pallet Height</label>
              <input type="number" class="form-control shadow-none rounded-0 text-black" v-model.number="form.PalletHeight" step="0.01" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Pallet Volume</label>
              <input type="number" class="form-control shadow-none rounded-0 text-black" :value="palletVolume" readonly />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Pallet Fill Rate</label>
              <input
                type="number"
                class="form-control shadow-none rounded-0 text-black"
                v-model.number="form.PalletFillRate"
                min="0"
                max="1"
                step="0.01"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Minimum Pallets Stored per SKU</label>
              <input
                type="number"
                class="form-control shadow-none rounded-0 text-black"
                v-model.number="form.MinimumPallets"
                min="1"
                step="1"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Minimum Days Picking Inventory</label>
              <input
                type="number"
                class="form-control shadow-none rounded-0 text-black"
                v-model.number="form.MinimumDays"
                min="0"
                step="0.1"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Simulation Days</label>
              <input
                type="number"
                class="form-control shadow-none rounded-0 text-black"
                v-model.number="form.SimulationDays"
                min="1"
                step="1"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">System Fill Rate</label>
              <input
                type="number"
                class="form-control shadow-none rounded-0 text-black"
                v-model.number="form.FillRate"
                min="0"
                max="1"
                step="0.01"
              />
            </div>
          </div>

          <div class="col-md-12">
            <button class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16" type="submit">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import { BASE_HSUITE_URL } from '@/core/constant/env';

export default defineComponent({
  name: 'CreatePalletSimulation',
  props: {
    dataStreamID: {
      type: Number,
      required: true,
    },
    leadID: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter();
    const skuTables = ref<any[]>([]);
    const form = ref({
      TableID: '',
      TotalLevels: 5,
      LocationQuantity: 750,
      PalletWidth: 1200,
      PalletDepth: 1000,
      PalletHeight: 1800,
      PalletFillRate: 0.85,
      MinimumPallets: 1,
      MinimumDays: 2,
      SimulationDays: 7,
      FillRate: 0.95,
    });

    const palletVolume = ref(
      (form.value.PalletWidth * form.value.PalletDepth * form.value.PalletHeight) /
        1_000_000_000
    );

    const fetchSkuTables = async () => {
      try {
        const response = await axios.get(`${BASE_HSUITE_URL}/api/DataTable/GetFilteredDataTables?LeadID=${props.dataStreamID}&tableID=SKUData`);
        skuTables.value = response.data.dataTables;
      } catch (error) {
        console.error('Error fetching SKU Tables:', error);
      }
    };

    watch(
      [
        () => form.value.PalletWidth,
        () => form.value.PalletDepth,
        () => form.value.PalletHeight,
      ],
      () => {
        palletVolume.value =
          (form.value.PalletWidth *
            form.value.PalletDepth *
            form.value.PalletHeight) /
          1_000_000_000;
      }
    );

    const submitForm = async () => {
      try {
        await axios.post(`${BASE_HSUITE_URL}/api/ELSA/RunPalletSimulation`, {
          TableName: form.value.TableID,
          TotalLevels: form.value.TotalLevels,
          LocationQuantity: form.value.LocationQuantity,
          PalletVolume: palletVolume.value,
          PalletFillRate: form.value.PalletFillRate,
          MinimumPallets: form.value.MinimumPallets,
          MinimumDays: form.value.MinimumDays,
          SimulationDays: form.value.SimulationDays,
          FillRate: form.value.FillRate,
        });
        alert('The analysis will continue to run in the background. The completed results tables will be added to the datastream when it is complete.');
        router.push({ name: 'DataTableOverview', params: { leadID: props.leadID, dataStreamID: props.dataStreamID } });
      } catch (error) {
        console.error('Form submission error:', error);
        alert('Error running pallet simulation.');
      }
    };

    watch(
      () => props.leadID,
      (newLeadID) => {
        if (newLeadID) {
          fetchSkuTables();
        }
      },
      { immediate: true }
    );

    return { form, skuTables, submitForm, palletVolume };
  },
});
</script>

<style scoped>
</style>

